import { useEffect, useLayoutEffect, useRef, useCallback } from 'preact/hooks'
import { TransitionState, useTransition } from './useTransition'
import { whenTransitionEnds } from './transition-util'

export interface CssTransitionProps {
  in: boolean
  appear?: boolean
}

// const classNamesMap: { [key in TransitionState]?: string } = {
//   preEnter: 'enter-from enter-active',
//   entering: 'enter-active enter-to',
//   preExit: 'leave-from leave-active',
//   exiting: 'leave-active leave-to',
// }

const classNamesMap: { [key in TransitionState]?: string } = {
  preEnter: 'before-enter enter-active',
  entering: 'enter-active enter',
  preExit: 'before-leave leave-active',
  exiting: 'leave-active leave',
}

const getClassName = (state: TransitionState): string => classNamesMap[state] || ''

export const useCssTransition = ({ in: _in, appear = false }: CssTransitionProps) => {
  const [state, toggle, endTransition] = useTransition({
    initialEntered: !appear && _in,
    mountOnEnter: true,
    unmountOnExit: true,
  })

  const targetRef = useRef<HTMLElement>(null)
  const ref = useCallback((el: HTMLElement | null): void => {
    targetRef.current = el
  }, [])

  const className = getClassName(state)

  useEffect(() => toggle(_in), [_in, toggle])

  useLayoutEffect(() => {
    const target = targetRef.current
    if (!target) {
      return
    }

    if (state !== 'exited' && state !== 'entered') {
      // force repaint
      // eslint-disable-next-line no-unused-expressions
      target.scrollTop
    }

    if (state === 'entering' || state === 'exiting') {
      return whenTransitionEnds(target, endTransition)
    }
  }, [state, endTransition])

  return { isMounted: state !== 'unmounted', ref, className }
}
